module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_90_100.086e87fb.png";